import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'shareit';
  public isMenuCollapsed = true;
  loggedIn = false
  isAdmin = false

  constructor(private serv: AppService, private router: Router) { 
    
  }

  hasCheckedLogin: boolean = false

  homeLinkHref = "/"
  homeLinkText = "ShareIt"

  iframeMode = true

  systemType = "udlaan"


  ngOnInit() {
    this.serv.isLoggedIn$.subscribe( x => {
      this.loggedIn = x

      this.isAdmin = this.serv.isAdmin
    })

    this.serv.rootInit().subscribe(ret => {
      this.homeLinkHref = ret['homeLinkHref']
      this.homeLinkText = ret['homeLinkText']
      this.iframeMode = ret['iframeMode']
      this.systemType = ret['systemType']
    })

    this.serv.checkLoggedIn().subscribe( _ => {
      this.hasCheckedLogin = true
    })
    //this.serv.checkLoggedIn().subscribe()
  }

  logout() {
    this.serv.logout().subscribe(_ => {
      this.loggedIn = false
      this.isAdmin = false
      this.serv.willGoBack = false
      this.router.navigate(['/'])
    })
  }
  
}
